import React, { useEffect, useState } from 'react';
import { ShieldCheck, Zap, Check, Crown } from 'lucide-react';
type PlanId = 'standard' | 'elite';
interface Plan {
  id: PlanId;
  name: string;
  price: string;
  oldPrice: string;
  url: string;
  highlight?: string;
}
const PLANS: Record<PlanId, Plan> = {
  standard: {
    id: 'standard',
    name: 'Hockey Pro System',
    price: '19.990',
    oldPrice: '49.990',
    url: 'https://checkout.ebookpoint.shop/cart/59423210209361:1'
  },
  elite: {
    id: 'elite',
    name: 'Hockey Pro System ELITE',
    price: '27.990',
    oldPrice: '69.990',
    url: 'https://checkout.ebookpoint.shop/cart/59460755914833:1',
    highlight: 'MÁS ELEGIDO'
  }
};
const ELITE_INCLUDES = ['Sistema de entrenamiento para delanteras', 'Sistema de entrenamiento para defensoras'];
export function PurchaseSection() {
  const [selectedPlan, setSelectedPlan] = useState<PlanId>('elite');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 58,
    seconds: 3
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  const active = PLANS[selectedPlan];
  return <section id="compra" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#142014] scroll-mt-10" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <div className="flex justify-center mb-[-18px] relative z-10" data-id="element-144">
          <div className="bg-[#c8e6c9] text-[#1a2e1a] font-bold px-8 py-2 rounded-t-xl uppercase tracking-widest text-xs shadow-lg" data-id="element-145">
            Oferta Especial - Hoy
          </div>
        </div>
        <div className="bg-gradient-to-b from-[#243824] to-[#1a2e1a] rounded-3xl p-6 md:p-10 border-2 border-[#c8e6c9] shadow-[0_0_50px_rgba(200,230,201,0.1)] relative overflow-hidden" data-id="element-146">
          <div className="text-center mt-2 mb-6" data-id="element-147">
            <h3 className="text-xl md:text-2xl font-bold text-[#faf5e8] mb-2" data-id="element-148">
              Elegí tu plan de entrenamiento
            </h3>
            <p className="text-[#a8c5a8] text-sm" data-id="element-149">
              Acceso inmediato al contenido digital
            </p>
          </div>

          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-150">
            <span className="text-red-400 text-xs font-bold uppercase tracking-wider" data-id="element-151">
              Termina en:
            </span>
            <div className="flex items-center gap-1 font-heading font-black text-[#faf5e8]" data-id="element-152">
              <span className="bg-red-900/30 border border-red-500/30 rounded px-2 py-1 text-sm" data-id="element-153">
                {formatTime(timeLeft.hours)}h
              </span>
              <span className="bg-red-900/30 border border-red-500/30 rounded px-2 py-1 text-sm" data-id="element-154">
                {formatTime(timeLeft.minutes)}m
              </span>
              <span className="bg-red-900/30 border border-red-500/30 rounded px-2 py-1 text-sm text-red-400" data-id="element-155">
                {formatTime(timeLeft.seconds)}s
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-156">
            <button onClick={() => setSelectedPlan('standard')} className={`relative text-left p-5 rounded-2xl border-2 transition-all ${selectedPlan === 'standard' ? 'border-[#c8e6c9] bg-[#1a2e1a] shadow-[0_0_20px_rgba(200,230,201,0.15)]' : 'border-green-800/50 bg-[#1a2e1a]/40 hover:border-[#c8e6c9]/50'}`} data-id="element-157">
              <div className="flex items-start justify-between mb-3" data-id="element-158">
                <div data-id="element-159">
                  <p className="text-xs uppercase tracking-wider text-[#a8c5a8] font-bold mb-1" data-id="element-160">
                    Estándar
                  </p>
                  <h4 className="font-heading font-bold text-[#faf5e8] text-lg leading-tight" data-id="element-161">
                    Hockey Pro System
                  </h4>
                </div>
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'standard' ? 'border-[#c8e6c9] bg-[#c8e6c9]' : 'border-[#a8c5a8]/40'}`} data-id="element-162">
                  {selectedPlan === 'standard' && <Check className="w-3 h-3 text-[#1a2e1a]" strokeWidth={3} data-id="element-163" />}
                </div>
              </div>
              <div className="flex items-baseline gap-2" data-id="element-164">
                <span className="text-[#a8c5a8] text-sm line-through" data-id="element-165">
                  ${PLANS.standard.oldPrice}
                </span>
                <span className="font-heading font-black text-[#c8e6c9] text-3xl" data-id="element-166">
                  ${PLANS.standard.price}
                </span>
              </div>
              <p className="text-[#a8c5a8] text-xs mt-2" data-id="element-167">
                6 capítulos + bonos gratis
              </p>
            </button>

            <button onClick={() => setSelectedPlan('elite')} className={`relative text-left p-5 rounded-2xl border-2 transition-all ${selectedPlan === 'elite' ? 'border-[#c8e6c9] bg-gradient-to-br from-[#1a2e1a] to-[#243824] shadow-[0_0_20px_rgba(200,230,201,0.2)]' : 'border-[#c8e6c9]/40 bg-[#1a2e1a]/40 hover:border-[#c8e6c9]/70'}`} data-id="element-168">
              {PLANS.elite.highlight && <span className="absolute -top-2.5 right-4 bg-[#c8e6c9] text-[#1a2e1a] text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-169">
                  {PLANS.elite.highlight}
                </span>}
              <div className="flex items-start justify-between mb-3" data-id="element-170">
                <div data-id="element-171">
                  <p className="text-xs uppercase tracking-wider text-[#c8e6c9] font-bold mb-1 flex items-center gap-1" data-id="element-172">
                    <Crown className="w-3 h-3" data-id="element-173" /> Elite
                  </p>
                  <h4 className="font-heading font-bold text-[#faf5e8] text-lg leading-tight" data-id="element-174">
                    Hockey Pro System{' '}
                    <span className="text-[#c8e6c9]" data-id="element-175">ELITE</span>
                  </h4>
                </div>
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'elite' ? 'border-[#c8e6c9] bg-[#c8e6c9]' : 'border-[#a8c5a8]/40'}`} data-id="element-176">
                  {selectedPlan === 'elite' && <Check className="w-3 h-3 text-[#1a2e1a]" strokeWidth={3} data-id="element-177" />}
                </div>
              </div>
              <div className="flex items-baseline gap-2" data-id="element-178">
                <span className="text-[#a8c5a8] text-sm line-through" data-id="element-179">
                  ${PLANS.elite.oldPrice}
                </span>
                <span className="font-heading font-black text-[#c8e6c9] text-3xl" data-id="element-180">
                  ${PLANS.elite.price}
                </span>
              </div>
              <p className="text-[#a8c5a8] text-xs mt-2" data-id="element-181">
                Todo lo del estándar + extras
              </p>
            </button>
          </div>

          {selectedPlan === 'elite' && <div className="mb-6 px-5 py-4 bg-[#142014]/60 border border-[#c8e6c9]/20 rounded-xl" data-id="element-182">
              <p className="text-[#c8e6c9] font-bold text-sm uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-183">
                <Crown className="w-4 h-4" data-id="element-184" /> ¿Qué incluye ELITE?
              </p>
              <ul className="space-y-2" data-id="element-185">
                {ELITE_INCLUDES.map((item, i) => <li key={i} className="flex items-start gap-2 text-[#d4d0c4] text-sm" data-id="element-186">
                    <Check className="w-4 h-4 text-[#c8e6c9] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-187" />
                    <span data-id="element-188">{item}</span>
                  </li>)}
              </ul>
            </div>}

          <div className="text-center" data-id="element-189">
            <a href={active.url} className="inline-flex flex-col items-center justify-center w-full md:w-auto bg-[#2e7d32] hover:bg-[#388e3c] text-[#faf5e8] font-heading font-black text-xl md:text-2xl py-5 px-12 rounded-2xl shadow-[0_0_30px_rgba(46,125,50,0.3)] transition-all transform hover:scale-105 hover:shadow-[0_0_40px_rgba(46,125,50,0.5)] uppercase tracking-wide group" data-id="element-190">
              <span data-id="element-191">Comprar Ahora</span>
              <span className="text-sm font-medium text-green-100 mt-1 normal-case tracking-normal opacity-90" data-id="element-192">
                {active.name} • ${active.price}
              </span>
            </a>

            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-4 text-[#a8c5a8] text-xs" data-id="element-193">
              <div className="flex items-center gap-2" data-id="element-194">
                <ShieldCheck className="w-4 h-4 text-[#4caf50]" data-id="element-195" />
                <span data-id="element-196">Compra 100% segura</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-green-800 rounded-full" data-id="element-197" />
              <div className="flex items-center gap-2" data-id="element-198">
                <Zap className="w-4 h-4 text-[#c8e6c9]" data-id="element-199" />
                <span data-id="element-200">Producto digital • Acceso inmediato</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}